import {
	IFilterDefinition,
	ISelectFilterDefinition,
	ITextFilterDefinition,
	OptionType
} from '@evinced-private/ui-common';

import { DevelopmentToggles, getSingleToggle } from 'src/common/services/TogglesService';

import { DEFAULT_PERIOD_OPTION } from '../../../common/helpers/DataFilterHelper';

export const NAME_NOT_PROVIDED = 'Name-not-Provided';

export const MAIN_PAGE_NAV_LABEL = 'All Tests';

export const DELETED_TEST_POPUP_TITLE = 'Test Not Found';
export const DELETED_TEST_POPUP_TEXT = 'This test has been deleted and is no longer available.';
export const DELETED_TEST_STATE_KEY = 'showDeletedTestPopup';

// Web SDK Tests Page - Selection and Actions
export const SELECT_TESTS_PROMPT = 'Select one or more tests to update the labels';
export const ADD_LABELS_BUTTON_LABEL = 'Add label';
export const CHANGE_LABEL_VALUE_BUTTON_LABEL = 'Change label value';
export const REMOVE_LABELS_BUTTON_LABEL = 'Remove label';
export const DELETING_TEST_MESSAGE = 'Deleting test';

export const TESTS_PERIOD_OPTIONS: OptionType[] = [
	DEFAULT_PERIOD_OPTION,
	{ value: 60, label: 'Last 60 days' },
	{ value: 90, label: 'Last 90 days' },
	{ value: 'all', label: 'All Tests' }
];

const enableWebSdkProperties = getSingleToggle(DevelopmentToggles.ENABLE_WEB_SDK_PROPERTIES);

const searchFilter: ITextFilterDefinition = {
	id: 'searchValue',
	label: 'Search',
	filterType: 'text',
	defaultValue: '',
	componentProps: {}
};

const propertiesFilter: ISelectFilterDefinition = {
	id: 'properties',
	label: 'properties',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select Property',
		allSelectedPlaceholder: 'All Properties',
		someItemsSelectedText: (numberOfItems: number) => `Properties (${numberOfItems})`,
		isMultiple: true,
		className: 'properties-filter-dropdown',
		id: 'properties',
		label: 'Property',
		listboxWidth: '150px'
	}
};

export const getWebSdkTestsFilterDefinitions = (
	labelsLoadOptions?: (searchText: string, callback: (options: OptionType[]) => void) => void,
	labelsOptions?: OptionType[]
): IFilterDefinition[] => {
	const labelsFilter: ISelectFilterDefinition = {
		id: 'labels',
		label: 'labels',
		filterType: 'select',
		defaultValue: [],
		componentProps: {
			placeholder: 'Select Label',
			allSelectedPlaceholder: 'All Labels',
			someItemsSelectedText: (numberOfItems: number) => `Labels (${numberOfItems})`,
			isMultiple: true,
			className: 'labels-filter-dropdown',
			id: 'labels',
			label: 'Label',
			...(labelsLoadOptions && { loadOptions: labelsLoadOptions }),
			...(labelsOptions && { options: labelsOptions }),
			...(labelsLoadOptions && { isSearchable: true })
		}
	};

	return [
		searchFilter,
		...(enableWebSdkProperties ? [propertiesFilter] : []),
		labelsFilter,
		{
			id: 'testPeriod',
			label: 'tests period',
			filterType: 'select',
			defaultValue: [DEFAULT_PERIOD_OPTION],
			componentProps: {
				placeholder: 'Select Tests Period',
				options: TESTS_PERIOD_OPTIONS,
				isMultiple: false,
				id: 'testPeriod',
				label: 'Test Period'
			}
		} as ISelectFilterDefinition
	];
};

export const webSdkIssuesFilterDefinitions: IFilterDefinition[] = [
	searchFilter,
	...(enableWebSdkProperties ? [propertiesFilter] : []),
	{
		id: 'urls',
		label: 'url',
		filterType: 'select',
		defaultValue: [],
		componentProps: {
			placeholder: 'Select URL',
			allSelectedPlaceholder: 'All URLs',
			someItemsSelectedText: (numberOfItems: number) => `URLs (${numberOfItems})`,
			isMultiple: true,
			className: 'url-filter-dropdown',
			id: 'urls',
			label: 'URLs'
		}
	} as ISelectFilterDefinition,
	{
		id: 'severities',
		label: 'severities',
		filterType: 'select',
		defaultValue: [],
		componentProps: {
			placeholder: 'Select Severity',
			allSelectedPlaceholder: 'All Severities',
			someItemsSelectedText: (numberOfItems: number) => `Severities (${numberOfItems})`,
			isMultiple: true,
			id: 'severities',
			label: 'Severities',
			listboxWidth: '140px'
		}
	} as ISelectFilterDefinition,
	{
		id: 'types',
		label: 'types',
		filterType: 'select',
		defaultValue: [],
		componentProps: {
			placeholder: 'Select Type',
			allSelectedPlaceholder: 'All Types',
			someItemsSelectedText: (numberOfItems: number) => `Types (${numberOfItems})`,
			isMultiple: true,
			id: 'types',
			label: 'Types'
		}
	} as ISelectFilterDefinition,
	{
		id: 'levels',
		label: 'levels',
		filterType: 'select',
		defaultValue: [],
		componentProps: {
			placeholder: 'Select Level',
			allSelectedPlaceholder: 'All Levels',
			someItemsSelectedText: (numberOfItems: number) => `Levels (${numberOfItems})`,
			isMultiple: true,
			id: 'levels',
			label: 'Levels',
			listboxWidth: '140px'
		}
	} as ISelectFilterDefinition
];
export const WEB_SDK_TEST_ISSUES_CSV_FILE_NAME_PREFIX = 'web-sdk-test-issues';
